import * as React from "react";
import { useState } from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { CheckboxGroup } from "../../../../Shared/CheckboxGroup/CheckboxGroup";
import { ServicePropositionMap } from "../../../../Shared/Entities/Maps/ServicePropositionMap";
import { BusinessManagementPropositionDispatcher, BusinessManagementPropositionStore } from "../Store/Variable";

interface IMultiplePropFilterProps {
    multiPropsFilter: ServiceProposition[];
    onCancel: VoidFunction;
    onApply: (selected) => void;
}

export const MultiplePropFilter = (props: IMultiplePropFilterProps) => {
    const [selectedProposition, setSelectedProposition] = useState<ServiceProposition[]>(
        BusinessManagementPropositionStore.getData()
    );
    const getPropositionList = () => {
        return props.multiPropsFilter.map((item, index) => {
            return {
                label: ServicePropositionMap.getString(item),
                onChange: (v) => {
                    if (v) {
                        setSelectedProposition(selectedProposition.concat(item));
                    } else {
                        setSelectedProposition(selectedProposition.filter((e) => e != item));
                    }
                },
                value: selectedProposition.some((x) => x == item),
                disabled: props.multiPropsFilter.length == 1,
            };
        });
    };

    return (
        <>
            <CheckboxGroup type={"block"} options={getPropositionList()} />
            <button className="btn secondary mr-10" onClick={() => props.onCancel()}>
                Cancel
            </button>
            <button
                className="btn primary"
                onClick={() => {
                    props.onApply(selectedProposition);
                    BusinessManagementPropositionDispatcher.dispatch({
                        actionType: ActionType.Success,
                        payload: selectedProposition,
                    });
                }}
                disabled={selectedProposition.length == 0}
            >
                {"Apply"}
            </button>
        </>
    );
};
